import { ListData } from '../../components/items-list/list-data.service';
import { AgreementModel } from '@fi-shared/fi-agreement/agreement.model';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '../../components/items-list/items-list-header';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class AgreementsListDataModel extends ListData<AgreementModel> {
    ObjectType = ObjectTypes.Agreement;
    ShowDelete = false;
    NameColumnIndex = 0;
    ShowCheckBox = false;

    constructor(injector: Injector, isLocalSort?: boolean, defaultColumn?: string, defaultReverse?: boolean) {
        super(injector, isLocalSort, defaultColumn, defaultReverse);

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.name'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: FiStateNames.Agreement.View._name,
                    SrefParams: function (data) {
                        return { Id: data.Id };
                    },
                    secondaryValue: (data) => {
                        return (
                            injector.get(FiFormatDateService).formatDate(data.ChangedOn, 'date') +
                            ' ' +
                            data.ChangedByUserName
                        );
                    },
                }),
            ),
        );

        this.addChangedOnHeader();
    }
}
